import Api from '@/services/api';
import {removeEmptyParams, transformDownloadResponse} from '@utils';
import contentDisposition from 'content-disposition';

export default {
  reviewsPagination(filter) {
    return Api()
      .post('/reviews/pagination', filter)
      .then((res) => this.formatResList(res.data));
  },
  reviewsStats(filter) {
    return Api()
      .post('/reviews/stats', removeEmptyParams(filter))
      .then((res) => res.data);
  },
  reply(id, message) {
    return Api()
      .put(`/reviews/${id}/reply`, {reply: message})
      .then((res) => res.data);
  },
  reviewDashboard(filter) {
    return Api()
      .get('/reviews/dashboard', {params: removeEmptyParams(filter)})
      .then((res) => this.formatRes(res.data));
  },
  reviewSidebar(id) {
    return Api()
      .get('/review/' + id + '/sidebar')
      .then((res) => this.formatRes(res.data));
  },
  exportList(filter) {
    return Api()
      .get('/reviews/export', {
        responseType: 'blob',
        transformResponse: [transformDownloadResponse],
        params: removeEmptyParams(filter),
      })
      .then((response) => {
        if (response.status === 204) throw new Error('Aucun avis à exporter');
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let fileName = contentDisposition.parse(response.headers['content-disposition']).parameters.filename;
        link.setAttribute('download', fileName);
        link.click();
        window.URL.revokeObjectURL(url);
      });
  },
  exportListForOwner(filter) {
    return Api()
      .get('/reviews/export/owner', {
        responseType: 'blob',
        transformResponse: [transformDownloadResponse],
        params: removeEmptyParams(filter),
      })
      .then((response) => {
        if (response.status === 204) throw new Error('Aucun avis à exporter');
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let fileName = contentDisposition.parse(response.headers['content-disposition']).parameters.filename;
        link.setAttribute('download', fileName);
        link.click();
        window.URL.revokeObjectURL(url);
      });
  },
  formatRes(e) {
    if (e.submittedAt) e.submittedAt = new Date(e.submittedAt);

    return e;
  },
  formatResList(e) {
    e.list.forEach((e) => {
      this.formatRes(e);
    });
    return e;
  },
};
